/*!
 * Built by Revolist
 */
import { R as RevogrData$1, d as defineCustomElement$1 } from './revogr-data2.js';

const RevogrData = RevogrData$1;
const defineCustomElement = defineCustomElement$1;

export { RevogrData, defineCustomElement };
